import { useMutation, useQuery } from "react-query";
import {
  changeStatusAgent,
  createAgent,
  getAgentById,
  getAgentsList,
  getListRoles,
  updateAgent,
} from "./agents-admin-service";

export const useGetAgentsList = (config?: any) => {
  return useQuery("agents/list", () => getAgentsList(), { ...config });
};

export const useGetAgentById = ({ id }: { id: string }, config?: any) => {
  return useQuery(["agents/list", id], () => getAgentById(id), {
    enabled: !!id,
    ...config,
  });
};

export const useGetRoles = (config?: any) => {
  return useQuery(["agent/roles"], () => getListRoles(), config);
};

export const useUpdateAgent = () => {
  return useMutation(({ data, id }: { data: any; id: string }) =>
    updateAgent(data, id),
  );
};

export const useCreateAgent = () => {
  return useMutation((data: any) => createAgent(data));
};

export const useChangeStatusAgent = () => {
  return useMutation((userID: string) => changeStatusAgent(userID));
};
